import { render, staticRenderFns } from "./allshops.vue?vue&type=template&id=041d04e4"
import script from "./allshops.vue?vue&type=script&lang=js"
export * from "./allshops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports